import * as React from 'react';
import { Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { RootState } from '@src/app/_redux';
import { connect } from 'react-redux';
import { ErrorMessage } from '@src/app/_global/components/error-messages/default-error-message';
import { getAdminConfigTableItem } from '@src/app/_global/utility/adminConfigUtils';

interface ResponseViewProps {
  onExit: () => void;
  sendEmailData: any;
  adminConfig: any;
  clientConfig: any;
}

const SuccessView: React.SFC<any> = (customMessage: any) => {
  let defaultCfmMessage: string = 'Thank You!';
  let defaultCfmMessage2: string = ' We have received your message and will reply shortly...normally within 2 business days.';
  let cfmMessge = customMessage.customMessage ? customMessage.customMessage : defaultCfmMessage2;
  return (
    <div>
      <Row>
        <Col xs={12} sm={12} md={12}>
          <header className="page-header" id="view-heading">
            <FormattedMessage
              id={'address.congratulations'}
              description={'congratulation message'}
              defaultMessage={defaultCfmMessage}
            />
          </header>
          <FormattedMessage 
            id={'address.congratulations'}
            description={'congratulation message'}
            defaultMessage={cfmMessge}
          />

       </Col>
      </Row>
    </div>
  );
};

export class ResponseViewComponent extends React.Component<ResponseViewProps> {

  render() {
    const {
      onExit,
      sendEmailData,
    } = this.props;
    let customerServiceAdminData = getAdminConfigTableItem(
      this.props.adminConfig,
      this.props.clientConfig,
      'CustomerService',
      sendEmailData.sendEmailResult.success ? sendEmailData.sendEmailResult.payload.selectedProdIdAlias : null,
    );
    let pageIntroTable = getAdminConfigTableItem(
      this.props.adminConfig,
      this.props.clientConfig,
      'PageIntro',
    );
    let pageIntro;
    if (pageIntroTable.PageIntroductions) {
      pageIntro = pageIntroTable.PageIntroductions.find(intro => {
        return intro.route === 'customer-service';
      });
    }
    let pageIntroDescHtml = document.getElementsByClassName('page-intro-desc') || null;
    if (pageIntroDescHtml && pageIntroDescHtml.length > 0) {
      pageIntroDescHtml[0].innerHTML = pageIntro ? (pageIntro.confDescription ? pageIntro.confDescription : pageIntro.description ) : '';
    }

    let pageHeadingLabelHtml = document.getElementsByClassName('page-intro-label') || null;
    if (pageHeadingLabelHtml && pageHeadingLabelHtml.length > 0) {
      pageHeadingLabelHtml[0].innerHTML = pageIntro ? pageIntro.label + ' Confirmation' : '';
    }

    return (
    <div className="email-response-view">
      <Row className="d-flex align-items-right">
        <Col xs={12} sm={12} md={12}>
          <div className="conf-print">
            <button
              tabIndex={0}
              className="print-page icon-blue pointer fa fa-2x fa-print print-btn no-print"
              title="Print this page."
              onClick={() =>  window.print()}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={12} md={12}>
          <div className="small-text mb-2" />
          <div className="mb-4">
            {sendEmailData && sendEmailData && sendEmailData.sendEmailResult.success && <SuccessView customMessage={customerServiceAdminData.ThankYouMessage}/>}
            {sendEmailData && sendEmailData.sendEmailResult && !sendEmailData.sendEmailResult.success && <ErrorMessage onReset={onExit} />}
          </div>
        </Col>
      </Row>
      <Row className="mt-auto">
        <Col xs={12} sm={12} md={12}>
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-secondary"
              type="button"
              onClick={onExit}
            >
              <FormattedMessage
                id={'app.cancel'}
                description={'close button text'}
                defaultMessage={'Close'}
              />
            </button>
          </div>
        </Col>
      </Row>
    </div>
  );
}
}

const mapStateToProps = (state: RootState) => {
  return {
    adminConfig: state.adminConfig,
    clientConfig: state.clientConfig,
    sendEmailData: state.account.customerServiceEmailData,           // Needed for potential error message
  };
};

export const ResponseView = connect(
  mapStateToProps,
)(ResponseViewComponent);
